import { Link } from "@tanstack/react-router";
import logo from "@/assets/logo2024.webp.asset.json";

export function SiteHeader() {
  return (
    <header className="sticky top-0 z-40 border-b border-border/70 bg-background/85 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <Link to="/" className="flex items-center gap-3">
          <img
            src={logo.url}
            alt="Bauer IP"
            className="h-9 w-auto"
            width={120}
            height={36}
          />
          <span className="hidden md:inline text-[0.7rem] uppercase tracking-[0.2em] text-muted-foreground border-l border-border pl-3">
            Karel Bauer · European IP Counsel
          </span>
        </Link>
        <nav className="flex items-center gap-6 text-sm">
          <Link
            to="/european-patents"
            className="text-foreground/80 hover:text-foreground transition-colors"
            activeProps={{ className: "text-foreground border-b-2 border-accent" }}
          >
            Patents
          </Link>
          <Link
            to="/eu-trademarks"
            className="text-foreground/80 hover:text-foreground transition-colors"
            activeProps={{ className: "text-foreground border-b-2 border-accent" }}
          >
            Trade Marks
          </Link>
          <Link
            to="/blog"
            className="text-foreground/80 hover:text-foreground transition-colors"
            activeProps={{ className: "text-foreground border-b-2 border-accent" }}
          >
            Blog
          </Link>
          <Link
            to="/patent-ai"
            className="hidden md:inline text-foreground/80 hover:text-foreground transition-colors"
            activeProps={{ className: "text-foreground border-b-2 border-accent" }}
          >
            Ask AI
          </Link>
          <a
            href="mailto:docket@bauerip.com?subject=Consultation%20inquiry"
            className="hidden sm:inline-flex items-center rounded-full bg-accent px-4 py-2 text-sm font-medium text-accent-foreground hover:bg-accent/90 transition-colors"
          >
            Contact
          </a>
        </nav>
      </div>
    </header>
  );
}
